import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';


export default function CustomSidebar({children,open,onClose,anchor='right',heading=""}) {

  return (
    <div>
      <Drawer  anchor={anchor} open={open} onClose={onClose}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px',position:"sticky",top: '0',backgroundColor: 'white',zIndex: '1000',borderBottom:"1px solid #e0e0e0"}}>
        <h3 style={{margin: '0px'}}>{heading}</h3>
        <CloseIcon onClick={onClose} style={{cursor: 'pointer'}} />
       
        </div>
      
        {children}
      </Drawer>
    </div>
  );
}